import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Message, MenuItem} from 'primeng/primeng';
// import { LoginService } from '../../service/login/login.service';
import { LoginService } from '../../../employee/service/login/login.service';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../employee/service/account/account.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public form: FormGroup;
    public email: AbstractControl;
    public password: AbstractControl;
    public submitted = false;
    public msgs: Message[] = [];
    public langs: Object;
    public openLang = false;
    public welcomeMsg: string;
    public loading: boolean = false;
    fieldTextType: boolean = false;

    constructor(
        fb: FormBuilder,
        private loginService: LoginService,
        private router: Router,
        public translate: TranslateService,
        private accountService: AccountService,
    ) {
        if(this.loginService.loggedIn()){
            let user=JSON.parse(localStorage.getItem('profile'));
            if(this.loginService.isEmployeeUser()) //isCandidateUser
                this.passwordDateChangeConfirmation(user);
        }
        this.translate.use('es');

        this.translate.get('welcome').subscribe((res: string) => {
            this.welcomeMsg = res;
        });

        this.form = fb.group({
            'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
            'password': ['', Validators.compose([ Validators.required, Validators.minLength(4) ])]
        });

        this.email = this.form.controls['email'];
        this.password = this.form.controls['password'];
    }

    public onSubmit(values: Object): void {
        this.submitted = true;

        if (this.form.valid) {
            this.loading = true;
            this.loginService.login(values).toPromise().then(
                response => {
                    localStorage.setItem('token', response.json().token);
                    this.loginService.refreshToken();
                    this.getAccount();
                    // this.loading = false;
                },
                error => {
                    this.loading = false;
                    let errorMsg = '';
                    if ( error.status === 401 ) {
                        this.translate.get('Unauthorized').subscribe((res: string) => {
                            errorMsg = res;
                        });
                    }

                    if ( error.status === 422 )
                        errorMsg = 'Error';

                    if ( error.status === 500 )
                        errorMsg = 'Error';

                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
                }
            );
        }
    }

    public getAccount() {
        if ( this.loginService.loggedIn() ) {
            this.accountService.getAccount().toPromise().then(
                response => {
                    localStorage.setItem('profile', JSON.stringify(response.json()));
                    if(this.loginService.isEmployeeUser()){
                        this.getAccountPermissions();
                    } else{
                        alert("No tiene usuario registrado");
                        this.loginService.logout();
                    }
                },
                error => {
                    let errorMsg = '';
                    if ( error.status === 401 ) {
                        this.translate.get('Unauthorized').subscribe((res: string) => {
                            errorMsg = res;
                        });
                    }

                    if ( error.status === 422 )
                        errorMsg = 'Error';

                    if ( error.status === 500 )
                        errorMsg = 'Error';

                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
                }
            );
        }
    }

    public getAccountPermissions() {
        if ( this.loginService.loggedIn() ) {
            this.accountService.getAccountPermissions().toPromise().then(
                response => {
                    localStorage.setItem('permissions', JSON.stringify(response.json()));
                    let user=JSON.parse(localStorage.getItem('profile'));
                    this.passwordDateChangeConfirmation(user);
                },
                error => {
                    let errorMsg = '';
                    if ( error.status === 401 ) {
                        this.translate.get('Unauthorized').subscribe((res: string) => {
                            errorMsg = res;
                        });
                    }

                    if ( error.status === 422 )
                        errorMsg = 'Error';

                    if ( error.status === 500 )
                        errorMsg = 'Error';

                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
                }
            );
        }
    }

    public openSelectLang() {
        event.preventDefault();
        this.openLang = !this.openLang;
    }

    public changeLang(lang) {
        event.preventDefault();
        this.translate.use(lang);
        this.openLang = false;
    }

    ngOnInit() {
        this.langs = [
            { label: 'Español', abr: 'es' },
            { label: 'English', abr: 'en' }
        ];
    }

    // public gotoRegisterHV() {
    //     this.router.navigate(['curriculum']);
    // }

    // public gotoNewUser() {
    //     this.router.navigate(['register']);
    // }

    toggleFieldTextType(field_password: number) {
        if(field_password == 1)
            this.fieldTextType = !this.fieldTextType;
    }
    public isCompanyUser(roles: any[]): boolean {
        return Array.isArray(roles) && roles.some(role => role && ('' + role.name).toLowerCase() === 'company');
    }

    passwordDateChangeConfirmation(user: any){
        var dayMin = 80, dayMax = 100;
        let password_date = new Date(user.password_change_at);
        let today = new Date();
        let diff = today.getTime() - password_date.getTime();  //msec
        let diff_day = Math.ceil(diff / (1000 * 3600 * 24));
        let homeUrl = this.isCompanyUser(user.roles) ? '/pages/selection/citations' : '/pages/dashboard';
        //
        if(diff_day < dayMin){
            this.msgs = [];
            this.msgs.push( { severity: 'success', summary: this.welcomeMsg } );
            this.router.navigate([homeUrl]);
        } else if(diff_day >= dayMin && diff_day < dayMax){
            alert("Debes actualizar tu contraseña, te quedan " + ((dayMax - 1) - diff_day) + " día(s)");
            this.router.navigate(['/pages/account/edit/user']);
        } else{
            this.loading = false;
            alert("Tu contraseña ha vencido, comunicate con el Área de Desarrollo");
            this.loginService.logout();
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/components/login/login.component.ts